export default "/app/global-wrapper-client/static/b38cc175cbbca562742283f11be10fdc.woff2";